<template>
	<div>
	<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
								aria-label="Open navigation menu">menu</button>-->
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click="login" @keypress="login" tabindex="0">{{$t('3323')}}</div>
			</section>
		</div>
    </header>
		<div class="d-flex h-full flex-column">
				<main class="main-wrapper full flex-grow-1 scroll-y">
						<div class="container container--small pdt-50 ">
								<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{ $t("836") }}</div>
								<div class="t-body1 t-color-bodyGrayA font-r mgt-8 pdl-24 pdr-24">{{ $t("837") }}</div>
								<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-50 pdb-8">
										<div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
												<div class="t-subtitle3 font-m">{{ $t("838") }}</div>
												<button class="mdc-icon-button content-trigger"><i
																class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i></button>
										</div>
										<div class="detail-content pdl-24 pdr-24 pdb-24">
												<div class="t-body3 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 pdr-40 t-size">
														{{ $t("839") }}
														<br />
														{{ $t("840") }}
														<br />
														{{ $t("841") }}
												</div>
										</div>
										<div class="divider"></div>
										<div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
												<div class="t-subtitle3 font-m">{{ $t("842") }}</div>
												<button class="mdc-icon-button content-trigger"><i
																class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i></button>
										</div>
										<div class="detail-content pdl-24 pdr-24 pdb-24">
												<div class="t-body1 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 pdr-40 t-size">
														{{ $t("843") }}<br />
														{{ $t("844", { str: managerPhone }) }}<br />
														{{ $t("845") }}
												</div>
												<div class="mgt-16">
														<div class="d-flex mgb-8 align-items-center">
																<div class="t-body3 t-color-bodyGrayA font-r ">{{ $t("846", { str: '' }) }}</div>
																<a :href="`mailto:${managerEmail}`" class="pdl-4 t-body3 t-color-signBlue font-r t-decoration-underline">
																		{{managerEmail}}
																</a>
														</div>
														<div class="d-flex mgb-8 align-items-center">
																<div class="t-body3 t-color-bodyGrayA font-r">{{ $t("847", { str: '' }) }}</div>
																<a :href="`mailto:${managerPhone}`" class="pdl-4 t-body3 t-color-signBlue font-r t-decoration-underline">
																	{{managerPhone}}
																</a>
														</div>
												</div>
										</div>
										<div class="divider"></div>
										<div class="d-flex align-items-center justify-content-between pdt-12 pdl-24 pdb-12 pdr-16">
												<div class="t-subtitle3 font-m">{{ $t("848") }}</div>
												<button class="mdc-icon-button content-trigger"><i
																class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i></button>
										</div>
										<div class="detail-content pdl-24 pdr-24 pdb-24">
												<div class="t-body1 t-color-bodyGrayA font-r l-spacing-48 t-line-h-28 pdr-40 t-size">
														{{ $t("849") }}
														<br />
														{{ $t("850") }}
														<br />
														{{ $t("851") }}
												</div>
												<div class="mgt-16">
														<div class="d-flex mgb-8 align-items-center">
																<div class="t-body3 t-color-bodyGrayA font-r">{{ $t("852", { str: '' }) }}</div>
																<a :href="`mailto:${managerEmail}`" class="pdl-4 t-body3 t-color-signBlue font-r t-decoration-underline">
																		{{managerEmail}}
																</a>
														</div>
														<div class="d-flex mgb-8 align-items-center">
																<div class="t-body3 t-color-bodyGrayA font-r">{{ $t("853", { str: '' }) }}</div>
																<a :href="`mailto:${managerPhone}`" class="pdl-4 t-body3 t-color-signBlue font-r t-decoration-underline">
																	{{managerPhone}}
																</a>
														</div>
												</div>
										</div>
								</div>
								<div class="pdl-24 pdr-24 mgb-50">
										<button
										@click="checkSignInStatus" @keypress="checkSignInStatus" tabindex="0"
												class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4 mgb-16">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{ $t("854") }}</span>
										</button>
										<button
										@click="resend" @keypress="resend" tabindex="0"
												class="mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText w-full b-radius4 ">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{ $t("855") }}</span>
										</button>
								</div>
						</div>
				</main>

		</div>
	</div>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import joinApi from "@/api/joinApi.js";
import memberApi from "@/api/memberApi.js";
import { MDCRipple } from '@material/ripple'
import loginApi from "@/api/loginApi.js"
import popupApi from "@/api/popupApi.js"
import { mapState, mapMutations } from "vuex";
import localStorageUtil from "@/utils/localStorageUtil";

export default {
	components: {
		TopAppBar,
	},
	data() {
		return {
			// title: '개인정보 보호정책',
			htmlPrivacypolicy: null,
			managerEmail: "",
			managerPhone: "",
			params : "",
			redirectPath: "",
			popupData: null,
			popupImage: null,
			socialFirstName: "",
			socialLastName: "",
			socialFullName: "",
			socialEmail: "",
			socialAuth: false,
			isDrawerOpen: false,
			staticMode: '',
			title: localStorage.getItem('brandName'),
      isIdpService: localStorageUtil.isIdpServiceValidate()
		};
	},

  mixins: [topAppBarMixin],

  mounted() {
		this.setMaterialUi()
		$(function () {
			$(".sign_dl dt").click(function () {
				$(this).parent("dl").toggleClass("active");
			});
		});

  if(document.querySelectorAll(".content-trigger")) {
		var contentTrigger = Array.from(document.querySelectorAll(".content-trigger"));
		contentTrigger.forEach((item)=>{
				item.addEventListener("click", function () {
					if ((this.firstChild.innerHTML) === 'keyboard_arrow_down') {
						this.firstChild.innerHTML = 'keyboard_arrow_up'
					} else {
						this.firstChild.innerHTML = 'keyboard_arrow_down'
					}
					this.parentNode.nextElementSibling.classList.toggle("d-none")
				});
		  })
    }
		this.setTopAppBarCloseOnly(localStorage.getItem("brandName"));
		this.params =JSON.parse(localStorage.getItem("userParams"));
		this.brandManager();
		// 약관정보 API 호출(call api Privacy Policy )
		joinApi
			.terms()
			.then((response) => {
				// console.log(response.data.data)
				const termsUrl = response.data.data.TERMS_OF_SERVICE;
				const privacyUrl = response.data.data.PRIVACY_STATEMENT;

				joinApi.policyContents(privacyUrl, "text").then((response) => {
					this.htmlPrivacypolicy = response.data;
				});
			})
			.catch((err) => {});
	  },
	  methods: {
		  ...mapMutations("join", [
						"SET_JOINSTART",
						"SET_SOCIAL_LINK",
						"SET_PUSH_NOTIFICATION",
						"SET_NAME_FIRST",
						"SET_NAME_LAST",
						"SET_NAME_FULL",
						"SET_LOGINID",
						"SET_SOCIAL_ID",
						"INIT_JOIN_STORE",
				]),

		  brandManager() {
			  joinApi
				  .managerDetail()
				  .then((response) => {
					  if (response.data.data) {
						  this.managerEmail = response.data.data.email;
						  this.managerPhone = response.data.data.phone;
					  }
				  }).catch((err) => {});
		  },

		  checkSignInStatus() {
        let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck();
        loginAuth.then((response) => {
							let responseData = response.data.data;
							let changePasswordRequest = responseData.changePasswordRequest;
							let reIssueChangePassword = responseData.reIssueChangePassword;
							let emailAuth = responseData.emailAuth;
							let dormancy = responseData.dormancy;
							let responsibilityAuth = responseData.responsibilityAuth;
							let termsAgree = responseData.termsAgree;
							let storeTransfer = responseData.storeTransfer;
							if (this.isIdpService) {
								loginApi.setAuthInHeader(responseData.token);
							}
							if (dormancy === true) {
									this.$alert({
										title: this.$t("824"),
										content:
											this.$t("825") +
											" " +
											this.$t("826") +
											"<br>" +
											this.$t("827", {
												str:
													'<a href="mailto:' +
													BRAND_MANAGER_EMAIL +
													'">' +
													BRAND_MANAGER_EMAIL +
													"</a>",
											}) +
											"<br>" +
											this.$t("828", {
												str:
													'<a href="tel:' +
													BRAND_MANAGER_PHONE +
													'">' +
													BRAND_MANAGER_PHONE +
													"</a>",
											}),
										accept: this.$t("829"),
									})
										.then(() => {
                      this.login();
										})
										.catch(() => {
                      this.login();
										});
								} else if (termsAgree === false) {
									this.$router.push("/termsagree");
								} else if (emailAuth === false) {
                  this.login();
								} else if (changePasswordRequest === true) {
									this.$router.push({ name: "MemberChangePassword" });
								} else if (reIssueChangePassword === true) {
                this.$router.push({ name: "MemberReIssueChangePassword" });
								} else if (responsibilityAuth === false) {
									this.$alert({
										title: this.$t("830"),
										content: this.$t("831") + " " + this.$t("832"),
										accept: this.$t("833"),
									})
										.then(() => {
											this.$router.push("/verificationcode");
										})
										.catch(() => {
                      this.login();
										});
								} else if (storeTransfer !== null) {
									this.$router.push({ name: "StoreTransfer" });
								} else {
									popupApi
										.fetpopupDetail()
										.then((response) => {
											this.popupData = response.data.data;
											if (this.popupData.length > 0) {
												this.redirectPath =
													this.$route.query.redirectPath || "/home?showPopup=1";
												this.$router.push(this.redirectPath);
											} else {
												this.redirectPath = this.$route.query.redirectPath || "/home";
												//this.redirectPath = this.$route.query.redirectPath || '/degree'
												this.$router.push(this.redirectPath);
											}
										})
										.catch((error) => {
											console.log("err", error);
										});

									//this.$router.push(this.redirectPath)
								}
							})
							.catch((err) => {
							const responseData = err.response.data.meta;
							if (responseData.errCode === 1201) {
									// 관리자 승인 대기중(Waiting for administrator approval)
									// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
									this.$alert({
									title: this.$t("779"), //가입 승인 대기 상태입니다.
									content:
											this.$t("780") +
											"<br>" +
											this.$t("781", {
											str:
													'<a href="mailto:' +
													BRAND_MANAGER_EMAIL +
													'">' +
													BRAND_MANAGER_EMAIL +
													"</a>",
											}) +
											"<br>" +
											this.$t("782", {
											str:
													'<a href="tel:' +
													BRAND_MANAGER_PHONE +
													'">' +
													BRAND_MANAGER_PHONE +
													"</a>",
											}),
									accept: this.$t("783"),
									})
									.then(() => {})
									.catch(() => {});
							} else if (responseData.errCode === 1202) {
									this.$alert({
									title: this.$t("779"), //가입 승인 대기 상태입니다.
									content:
											this.$t("780") +
											"<br>" +
											this.$t("781", {
											str:
													'<a href="mailto:' +
													BRAND_MANAGER_EMAIL +
													'">' +
													BRAND_MANAGER_EMAIL +
													"</a>",
											}) +
											"<br>" +
											this.$t("782", {
											str:
													'<a href="tel:' +
													BRAND_MANAGER_PHONE +
													'">' +
													BRAND_MANAGER_PHONE +
													"</a>",
											}),
									accept: this.$t("783"),
									})
									.then(() => {})
									.catch(() => {});
							} else if (responseData.errCode === 1204) {
									this.$alert({
									title: this.$t("1482"), //가입 승인 대기 상태입니다.
									content:
											this.$t("1483") +
											"<br>" +
											this.$t("1484") +
											": " +
											'<a href="mailto:' +
											BRAND_MANAGER_EMAIL +
											'">' +
											BRAND_MANAGER_EMAIL +
											"</a>" +
											"<br>" +
											this.$t("1485") +
											": " +
											'<a href="tel:' +
											BRAND_MANAGER_PHONE +
											'">' +
											BRAND_MANAGER_PHONE +
											"</a>",
									accept: this.$t("1486"),
									})
									.then(() => {})
									.catch(() => {});
							} else if (responseData.errCode === 1205) {
									this.$alert({
									title: this.$t("1914"), //가입 승인 대기 상태입니다.
									content:
											this.$t("1915") +
											" " +
											this.$t("1916") +
											"<br>" +
											this.$t("1917", {
											str:
													'<a href="mailto:' +
													BRAND_MANAGER_EMAIL +
													'">' +
													BRAND_MANAGER_EMAIL +
													"</a>",
											}) +
											"<br>" +
											this.$t("1918", {
											str:
													'<a href="tel:' +
													BRAND_MANAGER_PHONE +
													'">' +
													BRAND_MANAGER_PHONE +
													"</a>",
											}),
									accept: this.$t("1919"),
									})
									.then(() => {})
									.catch(() => {});
							} else if (responseData.errCode === 1105) {
									this.$alert({
									content: this.$t("1875"),
									accept: this.$t("1876"),
									})
									.then(() => {})
									.catch(() => {});
							} else if (responseData.errCode === 1335) {
									//아이디 계정 일시 정지(Suspend Account)
									// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
									this.$snackOpen({
									contents: this.$t("323"),
									btnDisplayYN: false,
									}).then(() => {});
							} else {
                this.login();
							}
				});
		},

		signOutFirebase() {
				firebase.auth().signOut();
		},

		login() {
      if (this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        this.$router.push("/login");
      }
		},

		resend() {
			memberApi
				.emailVarification({ authType: "EMAIL" })
				.then((response) => {
						this.$snackOpen({
							contents: this.$t("856"),
							btnDisplayYN: true,
							btnDisplay: this.$t("783")
						}).then(() => {this.login()})
				}).catch((err) => {
					this.$router.push("/emailvarificationresend");
				});
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
					let button = new MDCRipple.attachTo(el)
					return button
			})
		},
	}
};
</script>
